package team.platforma.aicombo.activity.auth.component.fragment

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.cross_m
import aicombo.composeapp.generated.resources.eye
import aicombo.composeapp.generated.resources.eye_line
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.produceState
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.text.intl.LocaleList
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import kotlinx.coroutines.delay
import kotlinx.datetime.Clock
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.annotation.KoinExperimentalAPI
import system_component_style.SystemStyle
import team.platforma.aicombo.activity.auth.component.fragment.password_restore.EnterRestoreMailFragment
import team.platforma.aicombo.activity.auth.component.fragment.registration.EnterEmailFragment
import team.platforma.aicombo.activity.main.MainApp
import team.platforma.aicombo.telegram.triggerTelegramOauth
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.aicombo.theme.colors.getOutlinedTextColors
import team.platforma.aicombo.theme.typography.FontWeights
import team.platforma.aicombo.theme.typography.Typography
import team.platforma.auth_presentable.viewModel.AuthViewModel
import team.platforma.extra_nav.component.fragment_component.Fragment
import team.platforma.extra_nav.component.fragment_component.FragmentBox
import team.platforma.extra_nav.navigator.activity.findNavHost
import team.platforma.extra_nav.utils.rememberKeyboardHeight
import team.platforma.multiplatform_material_extension.button.AppFilledButton
import team.platforma.multiplatform_material_extension.text_input.TextInput
import team.platforma.multiplatform_material_extension.ui.dialog.CommonDialog
import team.platforma.multiplatform_material_extension.ui.theme.isDark
import team.platforma.multiplatform_material_extension.ui.theme.rememberTheme


private const val AUTH_BLOCK_TIMEOUT = 60000L

@OptIn(KoinExperimentalAPI::class)
object AuthFragment : Fragment(
    route = "auth_fragment",
    fragmentBox = { componentNavigator, fragmentNavigator, paddingValues ->

        val focusManager = LocalFocusManager.current

        val keyboardHeight by rememberKeyboardHeight()

        FragmentBox(
            modifier = Modifier.fillMaxSize(), paddingValues
//            Modifier.fillMaxSize().then(
//                if (DEVICE.info().brand == "Apple") {
//                    Modifier.clickable(
//                        indication = null,
//                        interactionSource = remember { MutableInteractionSource() }
//                    ) {
//                        focusManager.clearFocus()
//                    }
//                } else {
//                    Modifier
//                }
//            )
        ) {

            var email by remember { mutableStateOf("") }
            var password by remember { mutableStateOf("") }
            var hidePassword by remember { mutableStateOf(true) }
            val validInput by produceState(initialValue = false, email, password) {
                value = checkValid(email, password)
            }

            val auth = koinViewModel<AuthViewModel>()

            var showErrorAuth by remember { mutableStateOf(false) }
            var debugMessage by remember { mutableStateOf("") }

            var showErrorDialog by remember { mutableStateOf(false) }

            var showLoader by remember { mutableStateOf(false) }

            var authErrorCount by rememberSaveable { mutableStateOf(0) }
            var isBlocked by rememberSaveable { mutableStateOf(false) }
            var blockEndTime by remember { mutableStateOf(0L) }

//            if (isBlocked) {
//                LaunchedEffect(Unit) {
//                    val blockDurationMillis = AUTH_BLOCK_TIMEOUT
//                    blockEndTime = Clock.System.now().toEpochMilliseconds() + blockDurationMillis
//                    delay(blockDurationMillis)
//                    isBlocked = false
//                    authErrorCount = 0
//                }
//            }

            val theme = rememberTheme()
            SystemStyle().darkStatusBarIcons(!theme.isDark())

            Column(
                modifier = Modifier.widthIn(max = 533.dp).fillMaxHeight()
                    .padding(horizontal = 16.dp).align(Alignment.Center),
            ) {
                Spacer(modifier = Modifier.weight(1f))
                Text(
                    text = "Авторизация",
                    modifier = Modifier.padding(vertical = 16.dp, horizontal = 16.dp),
                    style = Typography.text3xl(weights = FontWeights.Regular)
                )
                TextInput(
                    value = email,
                    onValueChange = {
                        email = it
                    },
                    modifier = Modifier.fillMaxWidth(),
                    label = {
                        Text(
                            text = "Введите адрес электронной почты"
                        )
                    },
                    placeholder = {
                        Text(
                            text = "Адрес электронной почты"
                        )
                    },
                    trailingIcon = {
                        if (email.isNotEmpty()) {
                            IconButton(
                                onClick = {
                                    email = ""
                                }
                            ) {
                                Icon(
                                    painter = painterResource(Res.drawable.cross_m),
                                    contentDescription = null
                                )
                            }
                        }
                    },
                    keyboardOptions = KeyboardOptions.Default.copy(
                        keyboardType = KeyboardType.Email,
                        hintLocales = LocaleList(Locale("en")),
                        imeAction = ImeAction.Next
                    ),
                    colors = getOutlinedTextColors()
                )

                Spacer(
                    modifier = Modifier.height(8.dp)
                )

                TextInput(
                    value = password,
                    onValueChange = {
                        password = it
                    },
                    modifier = Modifier.fillMaxWidth(),
                    label = {
                        Text(
                            text = "Пароль"
                        )
                    },
                    placeholder = {
                        Text(
                            text = "Введите пароль"
                        )
                    },
                    trailingIcon = {
                        IconButton(
                            onClick = {
                                hidePassword = !hidePassword
                            }
                        ) {
                            Icon(
                                painter = painterResource(if (hidePassword) Res.drawable.eye_line else Res.drawable.eye),
                                contentDescription = null
                            )
                        }
                    },
                    visualTransformation = if (hidePassword) PasswordVisualTransformation() else VisualTransformation.None,
                    keyboardOptions = KeyboardOptions.Default.copy(
                        keyboardType = KeyboardType.Password,
                        hintLocales = LocaleList(Locale("en")),
                        imeAction = ImeAction.Next
                    ),
                    colors = getOutlinedTextColors()
                )

                Spacer(
                    modifier = Modifier.height(24.dp)
                )

                AppFilledButton(
                    onClick = {
                        showLoader = true

//                        auth.signIn(
//                            email = email,
//                            password = password,
//                            onSuccess = {
//                                showLoader = false
//                                findNavHost().navigateToActivity(MainApp)
//                            },
//                            onError = {
//                                showLoader = false
//                                showErrorAuth = true
//                            }
//                        )
                        auth.authUser(
                            email,
                            password,
                            onSuccess = {
                            findNavHost().navigateToActivitySingleTop(MainApp)
                            }
                        )
                    },
                    enabled = validInput,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Text(
                        text = "Войти"
                    )
                }

                Spacer(modifier = Modifier.height(8.dp))
                AppFilledButton(
                    onClick = {
                        //Sign in through telegram
                        triggerTelegramOauth()
                    },
                    enabled = true,
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors().copy(
                        contentColor = AppColors.text().primary,
                        containerColor = Color.Blue
                    )
                ) {
                    Text(
                        text = "Войти через Telegram", color = Color.White
                    )
                }
                Spacer(modifier = Modifier.height(8.dp))
                AppFilledButton(
                    onClick = {
                        fragmentNavigator.navigate(fragment = EnterRestoreMailFragment)
                    },
                    enabled = true,
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors().copy(
                        contentColor = AppColors.text().primary,
                        containerColor = Color.Transparent
                    )
                ) {
                    Text(
                        text = "Забыли пароль?"
                    )
                }

                Spacer(modifier = Modifier.weight(1f))

                AppFilledButton(
                    onClick = {
                        fragmentNavigator.navigate(EnterEmailFragment)
                    },
                    enabled = true,
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors().copy(
                        contentColor = AppColors.text().primary,
                        containerColor = Color.Transparent
                    )
                ) {
                    Text(
                        text = "Ещё нет аккаунта? Зарегистрироваться"
                    )
                }
                Spacer(modifier = Modifier.height(8.dp))
                AppFilledButton(
                    onClick = {
                        //To restore password
                    },
                    enabled = true,
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors().copy(
                        contentColor = AppColors.text().primary,
                        containerColor = Color.Transparent
                    )
                ) {
                    Text(
                        text = "Если возникли вопросы - \nНапишите команде проекта"
                    )
                }

                Spacer(modifier = Modifier.height(24.dp))
                Spacer(
                    modifier = Modifier.height(keyboardHeight)
                )
            }

            if (showErrorAuth) {
                CommonDialog(
                    onDismiss = {
                        showErrorAuth = false
                    },
                    title = {},
                    customStyle = null,
                    properties = DialogProperties(usePlatformDefaultWidth = false)
                ) {
                    Text(
                        "Ошибка авторизации"
                    )
                }
            }


            if (showLoader) {
                focusManager.clearFocus()
                CommonDialog(
                    properties = DialogProperties(
                        dismissOnBackPress = false,
                        dismissOnClickOutside = false,
                        usePlatformDefaultWidth = true
                    ),
                    onDismiss = {}
                ) {
                    CircularProgressIndicator(
                        modifier = Modifier
                            .padding(8.dp)
                            .size(56.dp),
                        color = AppColors.bg.primary().default
                    )
                }
            }
        }
    }
)

private fun checkValid(email: String, password: String): Boolean {

    val enEmail = Regex("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}\$")
    val ruEmail = Regex("[а-яА-Я0-9._%+-]+@[а-яА-Я0-9.-]+\\.[а-яА-Я]{2,}\$")
    val emailValid = enEmail.matches(email) || ruEmail.matches(email)

    val passwordRegex = Regex("^[a-zA-Z0-9!@#$%^&*(),.?\":{}|<>_\\-+=/\\\\~`]*$")

    val passwordValid = password.length >= 6 && passwordRegex.matches(password)

    return emailValid && passwordValid
}